import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject, Observable, of } from 'rxjs';
import { fromPromise } from 'rxjs/internal-compatibility';

@Injectable({
  providedIn: 'root'
})
export class MapLoaderService {
  public isLoaded: boolean = false;
  public isComponentLoaded: boolean = false;

  loadedSubject = new Subject<boolean>();
  loadedComponent = new BehaviorSubject<boolean>(false);

  constructor() { }

  /**
   * Load the Map assets and toggle asset loaded status before attempting to render the map.
   * TODO: Figure out why atlas is not defined on runtime if assets are not added manually.
   */
  load(): Observable<boolean> {
    if(!this.isLoaded) {
      return fromPromise(this.azureMapLazyLoader().then(() => {
        this.isLoaded = true;
        return this.isLoaded;
      }));
    } else {
      return of(true);
    }
  }

  /** Return the Loaded Subject */
  observableComponent(): Observable<boolean> {
    return this.loadedSubject.asObservable();
  }

  /**
   * Render a Promise of Loading the assets before changing the behavior subject to true;
   */
  private azureMapLazyLoader() {
    return Promise.all([]);
  }
}
